import { SearchableSelect as SharedSearchableSelect, SearchableSelectProps } from '@seller/ui/SearchableSelect';
import { OptionRowsSkeleton } from './skeleton/OptionRowsSkeleton';
import './SearchableSelect.css';
export type { SearchableSelectOption } from '@seller/ui/SearchableSelect';
export { searchableSelectComponents } from '@seller/ui/SearchableSelect';

export function SearchableSelect(props: SearchableSelectProps) {
  return <SharedSearchableSelect {...props} loadingMessage={<OptionRowsSkeleton />} />;
}
